import React, { Component } from "react"
import { connect } from "react-redux";
import Header from "../../components/header";
import { enableMyAccount, verifyOtpEnableAcc } from "../../services/patient/action";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { NavLink } from "react-router-dom";
import validator from "validator";
import Loader from "react-loader-spinner";
import ThanksModel from "../common/Model/thanksModel";


class EnableAccount extends Component {
    constructor(props) {

        super(props)
        this.state = {
            otp: "",
            activateStatus: false,
            access_token: "",
            userId: "",
            emailId: "",
            mobile: "",
            openPopUp: false,

        };
    }


    handleChange = (e) => {
        this.setState({
            otp: e.target.value
        })
    };

    componentDidMount() {
        if (this.props.profileDetails) {
            let access_token = this.props.loginDetails;
            let data = this.props.profileDetails.commonUser
            let userId = data.userId;
            let emailId = data.email;
            let mobile = data.mobile;
            this.setState({
                access_token,
                userId,
                emailId,
                mobile
            })
        }
    }




    confirmOkay = () => {
        this.props.history.push("/login");

    }

    ActivateAcc = () => {
        var formBody = [];
        formBody.push("userId" + "=" + this.state.userId);
        formBody = formBody.join("&");

        this.props.enableMyAccount(this.state.access_token, formBody);
    }

    confirmOtp = (e) =>{
        e.preventDefault();
        const { access_token, emailId, mobile, otp } = this.state;
        let payload = {
            emailId,
            mobile,
            otp
        }
        this.props.verifyOtpEnableAcc(access_token, payload)
    }


    componentWillReceiveProps(nextProps) {

        if (nextProps.enableAccountstatus) {
            this.setState({
                activateStatus: true
            })
        }
        if (nextProps.verifyOtpEnableAccStatus) {
 
           this.setState({
            openPopUp :true
           })
        }
    };


    render() {

        const { isLoading } = this.props;

        return (
            <>
                {isLoading && (
                    <div className="pop-mod">
                        <div className="loder-back">
                            <Loader
                                type="Ball-Triangle"
                                color="#CC6900"
                                height="100"
                                width="100"
                            />
                        </div>
                    </div>
                )}

                <ToastContainer hideProgressBar autoClose={3000} />

                <div className="login-wrapper2">
                    <div className="login-sec">
                        <div className="login-box">
                            <form  onSubmit={this.confirmOtp} >
                                {!this.state.activateStatus &&
                                    <>
                                        <h4 className="enable-account-title" >Your Account is Disabled, to Activate Your Account Please Click on Activate Button </h4>
                                        <div className="login-btn">
                                            <button type="button" onClick={this.ActivateAcc}>Activate</button>
                                        </div>
                                    </>
                                }
                                <div className="row input-section" >
                                    {this.state.activateStatus &&
                                        <>
                                            <h4 className="enable-account-title" > Please Enter OTP to Confirm and Activate Your Account  </h4>

                                            <div className="form-group mt-2">
                                                <input type="password" onChange={this.handleChange}
                                                    name="otp" value={this.state.otp} placeholder="Enter OTP" />
                                                    <div class="input-icon"><img alt="" src="images/lock.png"/></div>




                                                <span className="error">This value is required</span>
                                            </div>



                                            <div className="form-group">
                                                <div className="login-btn">
                                                    <button type="submit">Submit</button>
                                                </div>
                                            </div>
                                        </>
                                    }


                                    <div className="form-group">
                                        <div className="agree-site-rule">

                                            <NavLink to="/login" >
                                                Back To Login
                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="footer-login">
                            <ul>
                                <li> <a href="https://ferndaleroad.com/about-us/"> About us</a></li>
                                <li><NavLink to="/Contact" > Contact and Support</NavLink></li>

                                <li><NavLink to="/PrivacyPage">Privacy Policy</NavLink></li>
                            </ul>
                        </div>


                    </div>


                </div>
                <ThanksModel text="Your Account is Activated Successfully, Click OK to login" status={this.state.openPopUp} confirmOkay={this.confirmOkay} />
            </>
        )
    }
}
const mapStateToProps = state => ({
    newPassStatus: state.commonReducer.newPassStatus,
    enableAccountstatus: state.patientReducer.enableAccountstatus,
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    verifyOtpEnableAccStatus: state.patientReducer.verifyOtpEnableAccStatus,
    isLoading: state.commonReducer.isLoading



});

const mapDispatchToProps = dispatch => ({
    enableMyAccount: (token, payLoad) => dispatch(enableMyAccount(token, payLoad)),
    verifyOtpEnableAcc: (token, payLoad) => dispatch(verifyOtpEnableAcc(token, payLoad))

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EnableAccount);
